/**
 * rtc 类型
 */
export enum RTCType {
  RealseeBrowserRTC = 'RealseeBrowserRTC',
  RealseeVRWebViewRTC = 'RealseeVRWebViewRTC',
  RealseeBrowserChimeRTC = 'RealseeBrowserChimeRTC',
}

export enum BuiltInRTCType {
  RealseeXTRTC = 'trtc',
  RealseeXChimeRTC = 'chime',
}
